module.exports = __webpack_public_path__ + "static/media/help.37823fac.svg";